import { Component, OnInit, Input, ViewChild, AfterViewInit ,ViewEncapsulation, AfterContentChecked} from '@angular/core';
import { Router } from '@angular/router';
import { ConversationContact as ConvContact, ConversationContact, Conversation, Attachment } from 'app/clmtlk/shared/model/conversationContacts';
import { Action } from 'app/clmtlk/shared/model/action';
import { ClmtlkSessionService } from 'app/clmtlk/shared/service/clmtlk-session.service';
import { HelperService } from 'app/common/service/model-helper.service';
import { ClmtlkService } from 'app/clmtlk/shared/service/clmtlk.service';
import { ToastrService } from 'ngx-toastr';
import {MenuModule, MenuItem} from 'primeng/primeng';
import { BlockUIService } from 'ng-block-ui';
import { WindowRefService } from 'app/common/service/window-ref.service';

@Component({
  selector: 'clmtlk-message-grid',
  templateUrl: './message-grid.component.html',
  styleUrls: ['./message-grid.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MessageGridComponent implements OnInit, AfterViewInit {



@Input() globalSearch: any;
@Input() convContacts: ConvContact[];
@ViewChild('inboxGrid') inboxGrid: any;
loggedinUser: ConversationContact;
items: MenuItem[];
deletedConversations:Conversation;
isDeletedConversationFound:boolean=false;
private window: Window;

  constructor(private router: Router,
    private clmtlkService: ClmtlkService,
    private clmtlkSessionService: ClmtlkSessionService,
    private blockUIService: BlockUIService,
    private helperService: HelperService,
    private toastrService: ToastrService,
    private windowService: WindowRefService) { 
      this.window = windowService.nativeWindow;
    }

  ngOnInit() {
    this.loggedinUser = this.clmtlkSessionService.loggedInContact;
    this.items = [{label: 'mark as read', icon: 'fa-envelope-open' },
                  {label: 'view more', icon: 'fa-commenting' }];

    this.deletedConversations = this.clmtlkService.deletedConversations
    if(this.deletedConversations){
      this.isDeletedConversationFound = true;
    }
    
    console.info("this.deletedConversations",this.deletedConversations);
  }

  displayContactAddress(conversationContacts: ConversationContact[], type: string): string {

    const loggedinUser: ConversationContact = this.clmtlkSessionService.loggedInContact;
    const isStreamUser: boolean = loggedinUser.CTC_SRC_CD === 'st';

    let contactAddress = '';
    let startIndex = 0;
    conversationContacts.forEach((conversationContact: ConversationContact) => {
      if (conversationContact.CTC_ADDR_TYP_CD === type) {

        let contactDisplay: string = conversationContact.contacts.contact[0].CTC_NM + 
                                      (conversationContact.CTC_IMPRS_NM ?
                                      `( ${conversationContact.CTC_IMPRS_NM} )` : '');
        if (isStreamUser) {
          contactDisplay = `${contactDisplay}( ${conversationContact.contacts.contact[0].CTC_VAL_TXT} )`;
        }

        if ( conversationContact.CTC_STS_CD.toUpperCase() !== 'V' ) {
          contactDisplay = `<i class="text-danger">${contactDisplay}</i>`;
        }

        contactAddress = (startIndex === 0) ? contactDisplay : contactAddress + ', ' + contactDisplay;
        startIndex++;
      }
    });
    return contactAddress;
  }

  showTransformedMessage(message: string) {
    return message.replace('<![CDATA[', '').replace(']]>', '');
  }

  ngAfterViewInit(): void {
    // Switch to Server side Pagination, Sorting, Filtering
    // See loadMoreInboxData function for more info
     this.inboxGrid.lazy = false;
  }

  onRowSelect(event) {
    this.markAsReadAndNavigateToThreadDetail(event.data);
    // this.navigateToThreadDetail(event.data);
  }

  onFilter(event) {
    console.dir(event);
    event.filteredValue = null;
  }

  viewMore(selectedRow) {
    this.navigateToThreadDetail(selectedRow);
  }

  rowStyleClass(rowData: any, rowIndex: number) {

    const conversationContacts: ConversationContact[] = rowData.messages.message[0]
                              .conversationContacts.conversationContact;
    let convesationContact: ConversationContact = null;
    const loggedInContact: ConversationContact = rowData.loggedInConversationContacts.conversationContact[0];

    conversationContacts.forEach(convesationContactObj => {
      if (convesationContactObj.MSG_READ_IND !== 'Y' && loggedInContact.CTC_ID === convesationContactObj.CTC_ID) {
          convesationContact = convesationContactObj;
      }
    });

    if (convesationContact) {
          return 'thick';
    }
    return 'thin';
  }



  showBoldForUnreadMessage(selectedRow: ConversationContact): boolean {
    const conversationContact = this.getConvContactByCTC_IDWithUnReadMsgInd(selectedRow);
    if (conversationContact) {
        return true;
    }
    return false;
  }

  getConvContactByCTC_IDWithUnReadMsgInd(conversationContact: ConversationContact): ConversationContact {

    const conversationContacts: ConversationContact[] = conversationContact.messages.message[0]
                              .conversationContacts.conversationContact;
    let returnConversationContact: ConversationContact = null;
    conversationContacts.forEach(convesationContactObj => {
      if (convesationContactObj.MSG_READ_IND !== 'Y' && this.loggedinUser.CTC_ID === convesationContactObj.CTC_ID) {
          returnConversationContact = convesationContactObj;
      }
    });
    return returnConversationContact;
  }


  markAsRead(selectedRow) {
    this.postConversationContacts([this.getConvContactByCTC_IDWithUnReadMsgInd(selectedRow)]);
  }

  markAllAsRead() {

    const conversationContacts: ConversationContact[] = [];
    this.convContacts.forEach(convContact => {
      const convCont = this.getConvContactByCTC_IDWithUnReadMsgInd(convContact);
      if (convCont) {
        conversationContacts.push(convCont);
      }
    });

    if (conversationContacts.length > 0) {
      this.postConversationContacts(conversationContacts);
    }

  }


  generateConversationPayload(conversationContacts: ConversationContact[]) {
    const cloneConversationContacts: ConversationContact[] = this.helperService.cloneDeep(conversationContacts);
    cloneConversationContacts.forEach(conversationContact => {
        conversationContact.MSG_READ_IND = 'Y';
        // Possible set Message and conversation as Null;
        conversationContact.messages = null;
        conversationContact.conversations = null;
        conversationContact.contacts = null;
        conversationContact.loggedInConversationContacts = null;
    });

    const payload = {
      conversationContacts: {
        conversationContact: cloneConversationContacts
      }
    };

    return payload;
  }


  postConversationContacts(conversationContacts: ConversationContact[]) {

    const payload = this.generateConversationPayload(conversationContacts);
    this.clmtlkService.postConversationContact(payload).subscribe(
      result => {
        conversationContacts.forEach(conversationContact => {
          conversationContact.MSG_READ_IND = 'Y';
        });
        this.toastrService.success(`Successfully Marked ${ result.length > 1 ? 'all' : '' } message as Read`, 'Success');
      },
      error => {
        this.toastrService.error(`failed to Mark  messages as Read - ${error}`, 'Unsuccessful',
            { closeButton: true, positionClass: 'toast-top-full-width', tapToDismiss: false , timeOut: 0});
      }

    );

  }

  markAsReadAndNavigateToThreadDetail(selectedRow: ConversationContact): void {
    const conversationContact = this.getConvContactByCTC_IDWithUnReadMsgInd(selectedRow);
    if (conversationContact) {
      this.blockUIService.start('main', 'Loading Message Details... please wait');
      const payload = this.generateConversationPayload([conversationContact]);
      this.clmtlkService.postConversationContact(payload).subscribe(
        result => {
          this.blockUIService.stop('main');
          this.navigateToThreadDetail(selectedRow);
        },
        error => {
          this.blockUIService.stop('main');
          this.toastrService.error(`failed to Mark  messages as Read - ${error}`, 'Unsuccessful',
              { closeButton: true, positionClass: 'toast-top-full-width', tapToDismiss: false , timeOut: 0});
        }
      );
     }else {
      this.navigateToThreadDetail(selectedRow);
     }
  }


  loadMoreInboxData(event) {
    console.dir(event);
  }

  navigateToThreadDetail(conversationContact: ConversationContact): void {
    const conv_id = conversationContact.CONV_ID;
    const thrd_id = conversationContact.THRD_ID;
    this.clmtlkSessionService.setOldPin(this.clmtlkSessionService.pinCode);
    this.clmtlkSessionService.setNewPin(conversationContact.conversations.conversation[0].CONV_SEC_PIN_TXT);
    this.clmtlkSessionService.setConversationContext(null, null, null);
    this.router.navigate(['/convo', conv_id, 'thread', thrd_id]);
  }

  downloadFile(attachment: Attachment) {
    this.blockUIService.start('main', 'Downloading file... please wait');
    this.clmtlkService.dowloadFile(attachment)
    .subscribe( blob => {
          // const blob1 = new Blob([blob], {type: 'image/jpg'});
          const userAgent = navigator.userAgent || navigator.vendor || this.window['opera'];
          this.window.URL = this.window.URL || this.window['webkitURL'];
          console.log(userAgent);
          const window = this.window;
          // For IE
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, attachment.ATTCH_FILE_NM);

          // For Mobile (ipad, iphone, ipod) Safari
          } else if (/iP(ad|hone|od).+MAC.OS.X/i.test(userAgent)) {
            console.log(' inside ios ');

            // Chrome IOS
            if (/CriOS/i.test(userAgent)) {
              const reader = new FileReader();
              reader.onloadend = function () { window.open(reader.result); };
              reader.readAsDataURL(blob);

            // Safari and others  /Version\/[\d\.]+.*Safari/i
            }else {
              const url = window.URL.createObjectURL(blob);
              window.location.href = url;
            }
          // All Other
          }else {
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
          }

          // importedSaveAs(blob, attachment.ATTCH_FILE_NM);
    }, error => {
     this.blockUIService.stop('main');
     this.toastrService.error(`File download Failed - ${error}`, 'Unsuccess',
              { closeButton: true, positionClass: 'toast-top-full-width', tapToDismiss: false , timeOut: 0} );
    },
     () => {
      this.blockUIService.stop('main');
     }
  );
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/inbox/message-grid/message-grid.component.ts